import { Exam } from "./exam";
import { Notifications } from "../../notifications";
export class Certificate {
    constructor(wrapper) {
        this.wrapper = wrapper;
        this.exams = [];
        this.certificateId = wrapper.dataset.certificateId;
        wrapper
            .querySelectorAll(Certificate.examWrapperSelector)
            .forEach((examWrapper) => {
            this.exams.push(new Exam(examWrapper, this.certificateId));
        });
    }
    onSelectedCertificateChanged(newCertificateId) {
        if (this.certificateId === newCertificateId) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    show() {
        this.wrapper.classList.remove("hidden");
        this.exams.forEach((exam) => exam.activate());
    }
    hide() {
        this.wrapper.classList.add("hidden");
        this.exams.forEach((exam) => exam.deactivate());
    }
    addToFormData(formData) {
        this.exams.forEach((exam) => exam.addToFormData(formData));
    }
    validate() {
        return this.checkHasSomeSession() && this.checkSessionValues();
    }
    checkSessionValues() {
        return this.exams.every((exam) => exam.validate());
    }
    checkHasSomeSession() {
        const hasSomeSession = this.exams.some((exam) => exam.hasSession());
        if (!hasSomeSession) {
            Notifications.error(noPrices);
        }
        return hasSomeSession;
    }
}
Certificate.examWrapperSelector = ".js-exam";
